module.exports = __webpack_public_path__ + "static/MyZenTv-24932e1422b391c8b72e4f599da6bc78.png";